// 周报管理
import axios from '@/libs/api.request'

// 账号名
export const authLogin = (data) => {
  return axios.request({
    data: data,
    url: `/api/auth/login`,
    method: 'post',
    headers: {
      isLogin: true
    }
  })
}

// 获取验证图片  以及token
export const captchaGet = (data) => {
  return axios.request({
    data: data,
    url: `/api/captcha/get`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}

// 滑动或者点选验证
export const captchaCheck = (data) => {
  return axios.request({
    data: data,
    url: `/api/captcha/check`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}

// 无纸化办公平台登录
export const logining = (data) => {
  return axios.request({
    url: '/api/auth/wzhbglogin',
    method: 'post',
    data: data,
    headers: {
      isLogin: true
    }
  })
}
